import React from "react";
import logo from "../../assets/logo-login.svg";
import './LoadingScreen.scss';
var LoadingScreen = function () {
    return (React.createElement("div", { className: "loaderScreenContainer" },
        React.createElement("img", { src: logo, className: "loadingScreenImg", alt: "logo", draggable: false })));
};
export default LoadingScreen;
